
const MINUTE = 60_000;
const SECOND = 1_000;

/**
 * Parse a timestring from the api.
 * @returns duration in milliseconds (int)
 */
function parseTimeString(value: string | any) {
	if (typeof value === 'string') {
		if (value.match(/^\d+s$/)) { // e.g. 30s
			return parseInt(value) * SECOND;
		} else if (value.match(/^\d+$/)) { // e.g. 30
			return parseInt(value) * SECOND;
		} else if (value.match(/^\d+m$/)) { // e.g. 30m
			return parseInt(value) * MINUTE;
		}
	}

	console.log(`Encountered unknown time string ${value}. Defaulting to 60 seconds`);
	return 60 * SECOND;
}

export default parseTimeString;
